import { actions } from '../../utils/constants';
import { mode } from '../../settings';

export const fetchAppData = () => ({
    type: actions.ASYNC_FETCH_APP_DATA,
});

export const fetchClass = (classId) => ({
    type: actions.ASYNC_FETCH_CLASS,
    payload: classId,
});

export const convertCode = (code) => ({
    type: actions.LOGIN_FROM_CODE,
    payload: { code },
});

export const updateDates = (data) => ({
    type: actions.ASYNC_UPDATE_TCCS_DATES,
    payload: data,
});

export const updateTccValue = (value) => ({
    type: actions.ASYNC_UPDATE_VALUE_TCC,
    payload: value,
});

export const cleanClasses = ()=>({
    type: actions.CLEAN_CLASSES,
});

export const uploadFilesNewEad = (data)=>({
    type: actions.ASYNC_UPLOAD_FILE_NEW_EAD,
    payload: data,
});

export const setIsSavingNewEad = (value)=>({
    type: actions.SET_IS_SAVING_NEW_EAD,
    payload: value,
});

export const updateAttachments = (newAttachments)=>({
    type: actions.ASYNC_UPLOAD_ATTACHMENTS,
    payload: newAttachments,
});

export const initTest = (type)=>({
    type: actions.ASYNC_INIT_TEST,
    payload: type,
});

export const disabledRedirect = (value)=>({
    type: actions.DISABLED_REDIRECT,
    payload: value,
});

export const notificateClient = (message) => ({ type: actions.REQUEST_ERROR, payload: { error: new Error(), message: message, hidden: mode.ALL } });

export const setLoadingTestsOnline = (value)=>({
    type: actions.SET_LOADING_TESTS_ONLINE,
    payload: value,
});



// WEBPACK FOOTER //
// ./src/components/app/app.actions.js